import { Link, useNavigate } from "react-router-dom";
import { ShoppingBag, User, Search, Menu, X } from "lucide-react";
import { useState } from "react";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";
import CartDrawer from "@/components/CartDrawer";
import LanguageSwitcher from "@/components/LanguageSwitcher";

export default function Header() {
  const { count, setOpen } = useCart();
  const { user } = useAuth();
  const [mobile, setMobile] = useState(false);
  const [search, setSearch] = useState("");
  const nav = useNavigate();

  const doSearch = (e) => {
    e.preventDefault();
    if (search.trim()) nav(`/shop?q=${encodeURIComponent(search.trim())}`);
  };

  return (
    <>
      <div className="bg-[#121212] text-[#FBF9F5] text-[11px] tracking-[0.2em] py-2 text-center uppercase font-medium">
        Complimentary Shipping on Orders Over ₹15,000 · Handcrafted in India
      </div>
      <header className="sticky top-0 z-40 bg-[#FBF9F5]/85 backdrop-blur-md border-b border-[#E2DDD5]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between gap-6">
          <button className="md:hidden" onClick={() => setMobile(true)} data-testid="nav-mobile-toggle"><Menu size={22} /></button>
          <div className="flex-1 md:flex-none">
            <Link to="/" className="font-serif text-2xl md:text-3xl tracking-[0.3em] font-medium" data-testid="nav-logo">LEE BAG</Link>
          </div>
          <nav className="hidden md:flex items-center gap-8 text-[13px] uppercase tracking-[0.15em]">
            <Link to="/shop" data-testid="nav-link-shop" className="hover:text-[#C5A059] transition">Shop</Link>
            <Link to="/shop?category=Handbags" data-testid="nav-link-handbags" className="hover:text-[#C5A059] transition">Handbags</Link>
            <Link to="/shop?new_arrival=true" data-testid="nav-link-new" className="hover:text-[#C5A059] transition">New Arrivals</Link>
            <Link to="/shop?bestseller=true" data-testid="nav-link-bestsellers" className="hover:text-[#C5A059] transition">Bestsellers</Link>
            <Link to="/story" data-testid="nav-link-story" className="hover:text-[#C5A059] transition">Our Story</Link>
          </nav>
          <div className="flex items-center gap-4">
            <LanguageSwitcher />
            <form onSubmit={doSearch} className="hidden lg:flex items-center border-b border-[#E2DDD5] pb-1">
              <Search size={16} className="text-[#8C867D]" />
              <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search" className="bg-transparent px-2 text-sm w-32 focus:outline-none" data-testid="nav-search-input" />
            </form>
            <Link to={user ? (user.role === "customer" ? "/account" : "/admin/dashboard") : "/login"} data-testid="nav-account"><User size={20} /></Link>
            <button onClick={() => setOpen(true)} className="relative" data-testid="nav-cart-button">
              <ShoppingBag size={20} />
              {count > 0 && <span className="absolute -top-2 -right-2 bg-[#C5A059] text-[#121212] text-[10px] w-4 h-4 rounded-full flex items-center justify-center font-bold">{count}</span>}
            </button>
          </div>
        </div>
      </header>
      {mobile && (
        <div className="fixed inset-0 z-50 bg-[#FBF9F5] p-6 md:hidden">
          <button onClick={() => setMobile(false)} className="mb-8" data-testid="nav-mobile-close"><X size={24} /></button>
          <nav className="flex flex-col gap-6 text-lg uppercase tracking-[0.15em]">
            <div className="mb-2"><LanguageSwitcher /></div>
            <Link to="/shop" onClick={() => setMobile(false)}>Shop</Link>
            <Link to="/shop?new_arrival=true" onClick={() => setMobile(false)}>New Arrivals</Link>
            <Link to="/shop?bestseller=true" onClick={() => setMobile(false)}>Bestsellers</Link>
            <Link to="/story" onClick={() => setMobile(false)}>Our Story</Link>
            <Link to="/account" onClick={() => setMobile(false)}>Account</Link>
          </nav>
        </div>
      )}
      <CartDrawer />
    </>
  );
}
